// extracted by mini-css-extract-plugin
export default {"productImgShadow":"HeroCarousel_productImgShadow__QSTww"};